import { render, staticRenderFns } from "./RatingResponse.vue?vue&type=template&id=793f3b73&scoped=true&"
import script from "./RatingResponse.vue?vue&type=script&lang=js&"
export * from "./RatingResponse.vue?vue&type=script&lang=js&"
import style0 from "./RatingResponse.vue?vue&type=style&index=0&id=793f3b73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793f3b73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRating,VRow})
